import { render, staticRenderFns } from "./GetCountriesCode.vue?vue&type=template&id=525388cf&scoped=true&"
import script from "./GetCountriesCode.vue?vue&type=script&lang=js&"
export * from "./GetCountriesCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525388cf",
  null
  
)

export default component.exports